/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { DocumentWorkflowAction } from '../models/document-workflow-action';
import { LocalisedString } from '../models/localised-string';
export interface DocumentWorkflowStep {
  actions?: Array<DocumentWorkflowAction> | null;

  /**
   * Code
   */
  code?: string | null;
  icon?: string | null;
  name?: LocalisedString;
}

export class DocumentWorkflowStep {
  actions?: DocumentWorkflowAction[] | null;
  code?: string | null;
  icon?: string | null;
  name?: LocalisedString;

  constructor(value: DocumentWorkflowStep) {
    this.actions = value?.actions?.map((x) => new DocumentWorkflowAction(x));
    this.code = value?.code;
    this.icon = value?.icon;
    this.name = value?.name ? new LocalisedString(value.name) : undefined;
  }
}
